import React from "react"
import {useContentContext} from "../utils/ContentProvider"
import { useDisclosure } from "@mantine/hooks"
import { Modal, Button } from "@mantine/core"
import {Link} from "react-router-dom";
import StaticContents from "../utils/staticContents";

const Footer = () => {
  const { translations } = useContentContext()
  const [activeContent, setActiveContent] = React.useState<string>("")
  const [opened, { open, close }] = useDisclosure(false)

  return (
    <footer className="flex flex-col sm:justify-center sm:items-center px-4 py-6 space-y-2 sm:space-y-0 sm:space-x-4 text-center text-sm font-normal text-gray-500 border-t">
      <div className="mb-4">
        {translations.footer.description}
      </div>
      <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 text-sm font-medium text-gray-500 hover:text-gray-700">
        <Link
          to={"#"}
          onClick={() => {
            setActiveContent("insuranceAgent")
            open()
          }}
        >
          {translations.footer.insuranceAgent}
        </Link>
        <Link
          to={"#"}
          onClick={() => {
            setActiveContent("remoteSales")
            open()
          }}
        >
          {translations.footer.remoteSales}
        </Link>
        <Link
          to={"#"}
          onClick={() => {
            setActiveContent("privacy")
            open()
          }}
        >
          {translations.footer.privacy}
        </Link>
      </div>
      <Modal
        opened={opened}
        onClose={close}
        title={translations.footer.privacy}
        fullScreen
        radius={0}
        transitionProps={{ transition: 'fade', duration: 200 }}
      >
        <div className="px-4 py-6">
          {StaticContents(activeContent)}
        </div>
      </Modal>
    </footer>
  )
}

export default Footer
